import Vue from 'vue'
import { v4 as uuidv4 } from 'uuid'
export default {
  props: {
    default: {
      required: true
    }
  },
  data () {
    return {
      id: `id_${uuidv4()}`,
      model: undefined
    }
  },
  methods: {
    setModel () {
      Vue.set(this, 'model', this.default)
    }
  },
  watch: {
    default () {
      this.setModel()
    },
    model () {
      this.$emit('changeValue', { value: Number(this.model) || this.model })
    }
  }
}
